import { createContext, useContext } from 'react'

export interface GuildContextType {
  guild?: wowaudit.Guild
  guildReference?: wowaudit.GuildReference
  currentTeam?: wowaudit.Team
  teamReference?: wowaudit.TeamReference
}

export const GuildContext = createContext<GuildContextType>(
  {} as GuildContextType,
)

export const useGuild = () => {
  const context = useContext(GuildContext)
  if (context === undefined) {
    throw new Error('useGuild must be used within a GuildProvider')
  }

  return context
}

export default GuildContext
